<template>
  <div class="info_detal_r panel_bg">
    <div class="side_sticky">
      <div class="booking_price" v-if="$objBaseInfo.channelId == 'WEB'">
        <div class="total-price">
          <div class="title">{{ $t("BOOKING.TOTALPRICE") }}</div>
          <div class="title">
            <el-tooltip v-if=" ParentData.taxesInfo.hasTax" class="item" effect="light" :content="(ParentData.taxesInfo.taxAmount ? $t('DETAIL.TOTALTAXES')+ParentData.taxesInfo.taxCurrency+ParentData.taxesInfo.taxAmount : '') +' ' + (ParentData.taxesInfo.others ?$t('DETAIL.TOTALFEES') +ParentData.taxesInfo.otherCurrency+ParentData.taxesInfo.others : '')" placement="bottom-start">
              <span class="el-icon-info"></span>
            </el-tooltip>
            {{ showTotalPrice() }}
            <span v-if="ParentData.taxesInfo.hasTax">({{ $t("DETAIL.TAXIN") }})</span>
          </div>
          <!-- <div class="value">{{ this.$objBaseInfo.defaultCurrencySign + totalPrice }}</div> -->
        </div>
        <div class="price_link main_link_tab" @click="showPriceDialog">{{ $t("BOOKING.PRICELINK") }}</div>
      </div>
      <div class="content-title">{{ $t("BOOKING.NOTES") }}
        <span :style="{ color: $objBaseInfo.channelId == 'MOBILE' ? '#fc6640' : undefined }" v-if="this.ParentData.cancellationPolicy.type == 0">{{$t("BOOKING.POLICIES1")+" "+$t("BOOKING.POLICIES4")}}</span>
        <span v-if="this.ParentData.cancellationPolicy.type == 1">{{$t("BOOKING.POLICIES2")}}</span>
        <span v-if="this.ParentData.cancellationPolicy.type == 2">{{$t("BOOKING.POLICIES3")}}</span>
      </div>
      <div class="policies_title" v-if="this.ParentData.cancellationPolicy.type == 2"></div>
      <div class="guarantee_rules" v-if="this.ParentData.cancellationPolicy.type == 2">
        <ul>
          <li v-html="getPolicyText()"></li>
          <li>{{ $t("BOOKING.POLICY2") }}</li>
          <li v-if="this.ParentData.intlTaxDisplay == 1">{{ $t("BOOKING.INTLTAXDISPLAY") }}</li>
        </ul>
      </div>
      <div class="guarantee_rules" v-else-if="this.ParentData.intlTaxDisplay == 1">
        <ul>
          <li>{{ $t("BOOKING.INTLTAXDISPLAY") }}</li>
        </ul>
      </div>
      <div class="policies_title">
        <div class="content-title">{{ $t("BOOKING.GUARANTEE") }}
          <span>{{ParentData.bookingCreateParam.guaranteeRules ? $t("BOOKING.ALLGUARANTEE" + ParentData.bookingCreateParam.guaranteeRules) : ""}}</span>
        </div>
        <!--  -->
        <div class="guarantee_rules" v-if="ParentData.bookingCreateParam.guaranteeRules == 1 ||ParentData.bookingCreateParam.guaranteeRules == 2">
          <ul>
            <li>{{ $t("BOOKING.ALLGUARANTEEFEE") }}</li>
            <li>
              {{ $t('BOOKING.GUARANTEEDES_PART1') }}
              <a :href="$t('BOOKING.GUARANTEEDES_LINK')" target="_blank">
                {{ $t('BOOKING.GUARANTEEDES_LINK') }}
              </a>
              {{ $t('BOOKING.GUARANTEEDES_PART2') }}
            </li>
            <li v-if="ParentData.bookingCreateParam.paymentType == 1 && (ParentData.bookingCreateParam.source == 'sabre'|| ParentData.bookingCreateParam.source == 'sabre-oversea' || ParentData.bookingCreateParam.source == 'booking'|| ParentData.bookingCreateParam.source == 'booking-oversea')" v-html="$t('BOOKING.DISCLAIMER')"></li>
          </ul>
        </div>
        <div class="guarantee_rules" v-if="ParentData.bookingCreateParam.guaranteeRules == 5">
          <ul>
            <li>{{ $t("BOOKING.ALLGUARANTEEFEE2") }}</li>
            <li>
              {{ $t('BOOKING.GUARANTEEDES_PART1') }}
              <a :href="$t('BOOKING.GUARANTEEDES_LINK')" target="_blank">
                {{ $t('BOOKING.GUARANTEEDES_LINK') }}
              </a>
              {{ $t('BOOKING.GUARANTEEDES_PART2') }}
            </li>
            <li v-if="ParentData.bookingCreateParam.paymentType == 1 && (ParentData.bookingCreateParam.source == 'sabre'|| ParentData.bookingCreateParam.source == 'sabre-oversea' || ParentData.bookingCreateParam.source == 'booking'|| ParentData.bookingCreateParam.source == 'booking-oversea')" v-html="$t('BOOKING.DISCLAIMER')"></li>
          </ul>
        </div>
        <div>
          <ul>
            <li>&nbsp;</li>
            <li class="content-title">{{ $t('BOOKING.Reminder') }}</li>
            <li>{{ $t(pointsMessage) }}</li>
            <li>&nbsp;</li>
          </ul>
        </div>
        <div v-if="ParentData.bookingCreateParam.rdescription">
          <ul>
            <li v-if="!ParentData.bookingCreateParam.isIntegral">&nbsp;</li>
            <li>{{ getProductCode() }}</li>
            <li v-if="ParentData.bookingCreateParam.breakfastDescription!=''">
              <div><span style="font-weight: bold;" class="title-text">{{$t("BOOKING.BreakFastAnalysis")}}</span>
                <span  class="title-text" v-if="ParentData.bookingCreateParam.breakfastDescription=='True'">
                  {{ $t("BOOKING.BreakFastIncludingBreakfast") }}
                </span>
                <span  class="title-text" v-if="ParentData.bookingCreateParam.breakfastDescription=='False'">
                  {{ $t("BOOKING.BreakFastBreakfastExcluded") }}
                </span>
                <el-tooltip
                  placement="top"
                  effect="dark"
                  trigger="hover"
                >
                  <!-- 提示内容插槽 -->
                  <template #content>
                    <div class="tooltip-content" style="white-space: pre-line; vertical-align: middle;">
                      {{ $t("BOOKING.BreakFastAnalysisFailMessage") }}
                    </div>
                  </template>
                  <svg-icon
                    icon-class="question"
                    style="width: 2rem; height: 2rem;line-height:2rem;"
                  ></svg-icon>
                </el-tooltip>
              </div>
            </li>
            <li>{{ ParentData.bookingCreateParam.rdescription }}</li>
            <li>&nbsp;</li>
          </ul>
        </div>
      </div>
      <div class="chk_noWte">
        <el-checkbox v-model="checked">{{ $t("BOOKING.CHECKNOTES") }}</el-checkbox>
      </div>
      <div class="info colorRed" v-if="ParentData.bookingCreateParam.bookingType == 'bur' && ParentData.bookingCreateParam.source != 'CWTbur'">{{ $t("BOOKING.BURBOOKINGTITLE") }}</div>
      <div class="booking_price" v-if="$objBaseInfo.channelId == 'MOBILE'">
        <div class="total-price">
          <div class="title">{{ $t("BOOKING.TOTALPRICE") }}</div>
          <div class="title" style="font-size: 2.8rem;">
            <el-tooltip v-if=" ParentData.taxesInfo.hasTax" class="item" effect="light" :content="(ParentData.taxesInfo.taxAmount ? $t('DETAIL.TOTALTAXES')+ParentData.taxesInfo.taxCurrency+ParentData.taxesInfo.taxAmount : '') +' ' + (ParentData.taxesInfo.others ?$t('DETAIL.TOTALFEES') +ParentData.taxesInfo.otherCurrency+ParentData.taxesInfo.others : '')" placement="bottom-start">
              <span style="font-size: 14px;" class="el-icon-info"></span>
            </el-tooltip>
            <span style="font-size: 14px;font-family: 'Source-Sans-Pro-Semibold';">{{ currencySignText }}</span>
            {{ ParentData.totalPrice }}
            <span v-if="ParentData.taxesInfo.hasTax">({{ $t("DETAIL.TAXIN") }})</span>
          </div>
          <!-- <div class="value">{{ this.$objBaseInfo.defaultCurrencySign + totalPrice }}</div> -->
        </div>
        <div class="price_link main_link_tab" @click="showPriceDialog">{{ $t("BOOKING.PRICELINK") }}</div>
      </div>
      <div class="btn_submit" v-if="ParentData.isSubmit">
        <button class="s_btn s_btn_small btn_submit_book"
          v-bind:class="{ 'is-disabled': !checked }"
          @click="verifyRepeatOrder()"
          :disabled="!checked">
          {{ $t("BOOKING.SUBMIT") }}
        </button>
      </div>
    </div>
    <!-- begin price dialog -->
    <el-dialog v-model="showPriceFlag" :title="$t('PRICEDIALOG.TITLE')" width="60rem" :destroy-on-close="true" class="price-dialog">
      <el-divider class="title-divider"></el-divider>
      <el-table :data="transData" :show-header="false">
        <el-table-column align="center" class-name="el-header-price" fixed>
          <template #default="scope">{{ scope.row[0] }}</template>
        </el-table-column>
        <el-table-column 
          v-for="item in columnLength"
          :key="item"
          align="center"
          :width="130"
        >
          <template #default="scope">{{ scope.row[item] }}</template>
        </el-table-column>
      </el-table>
    </el-dialog>
    
    <el-dialog v-model="showMobilePriceFlag" :title="$t('PRICEDIALOG.TITLE')" width="90%" class="price-dialog">
      <el-divider class="title-divider"></el-divider>
      <el-table :data="ParentData.originData" max-height="300" style="width: 100%">
        <el-table-column prop="date" align="center" :label="$t('PRICEDIALOG.DATE')"></el-table-column>
        <el-table-column prop="price" align="center" :label="$t('PRICEDIALOG.PRICE')"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- end price dialog -->
  </div>
</template>
<script>
export default {
  name: "Booking_Right",
  inject: ['ParentData'],
  data(){
    return{
      checked: false,
      originTitle: [],
      showPriceFlag: false,
      showMobilePriceFlag: false,
      transData: [],
      columnLength: 0,
    }
  },
  mounted() {
  },
  computed: {
    pointsMessage() {
      const val = this.ParentData.bookingCreateParam.isIntegral;
      if (val === true) return "BOOKING.RoomTypePoints";
      if (val === false) return "BOOKING.RoomTypeNoPoints";
      return "BOOKING.RoomTypeConfirmPoints";
    },
    currencySignText() {
      const currencyCode = this.$objBaseInfo.defaultCurrencyCode ||
        this.ParentData.bookingCreateParam.currencyCode ||
        this.ParentData.dailyPrices?.[0]?.CurrencyCode ||
        "";
      return this.$objBaseInfo.defaultCurrencySign || this.$currencySign[currencyCode] || currencyCode;
    },
  },
  methods: {
    convertCancellationDate() {
      var cancellationDateMsg = this.ParentData.cancellationPolicy.cancellationDate +" " + this.ParentData.cancellationPolicy.deadlineTime +":00";
      if(this.ParentData.bookingCreateParam.source.indexOf('sabre')>=0 && this.$objBaseInfo.destinationType == "I" && !this.$objBaseInfo.isGATCity){
        return cancellationDateMsg + this.$t("CONFIRMATION.LocalTime");
      }
      if(this.ParentData.bookingCreateParam.source.indexOf('booking')>=0 && this.$objBaseInfo.destinationType == "I" && !this.$objBaseInfo.isGATCity){
        return cancellationDateMsg + this.$t("CONFIRMATION.BeijingTime");
      }
      return cancellationDateMsg;
    },
    showTotalPrice() {
      return `${this.currencySignText}${this.ParentData.totalPrice || 0}`;
    },
    getPolicyText() {
      const date = this.convertCancellationDate();
      const policyText = this.$t("BOOKING.POLICY1", [date]);
      // 将【日期】部分替换为加粗版本
      if(this.$objBaseInfo.channelId == 'MOBILE'){
        return policyText.replace(`【${date}】`, `<strong>【${date}】</strong>`)
                         .replace(`[${date}]`, `<strong>[${date}]</strong>`);
      }else{
        return policyText;
      }
    },
    showPriceDialog() {
      if (this.$objBaseInfo.channelId == "WEB") {
        this.originTitle = [];
        // 竖向表格标题
        this.originTitle.push(this.$t("PRICEDIALOG.DATE") + "：");
        this.originTitle.push(this.$t("PRICEDIALOG.PRICE") + "：");
        this.columnLength = this.ParentData.originData.length + 1;
        // 数组按矩阵思路, 变成转置矩阵
        let matrixData = this.ParentData.originData.map((row) => {
          let arr = [];
          for (let key in row) {
            arr.push(row[key]);
          }
          return arr;
        });
        // 加入标题拼接最终的数据
        this.transData = matrixData[0].map((col, i) => {
          return [
            this.originTitle[i],
            ...matrixData.map((row) => {
              return row[i];
            }),
          ];
        });
        this.showPriceFlag = true;
      } else {
        this.showMobilePriceFlag = true;
      }
    },
    verifyRepeatOrder(){
      this.ParentData.verifyRepeatOrder();
    },
    getProductCode(){
      if(this.ParentData.bookingCreateParam.productCode){
        return this.$t("BOOKING.productCode", { productCode: this.ParentData.bookingCreateParam.productCode });
      }
      return "";
    },
  },
}
</script>
<style lang="stylus" scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .info_detal_r {
    width: unset;
    padding: 1.3rem;
    font-size: 1.2rem;
    font-weight: 400;
  }
  .side_sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }
  .total-price {
    font-size: 2rem;
    line-height: 3.2rem;
    display: flex;
    justify-content: space-between;
    padding-top: 1.3rem;
  }
  .price_link {
    text-align: right;
    padding-bottom: 1.3rem;
    font-size: 1.4rem;
    line-height: 2.5rem;
    color: $btn-bg-color;
  }
  .content-title {
    font-size: 1.6rem;
    font-weight: 600;
    color: black;
    margin-top: 1rem;
  }
  .policies_title {
    line-height: 2rem;
    font-size: 1.4rem;
    padding: 0.5rem 0px;
  }
  .guarantee_rules {
    font-size: 1.2rem;
    ul {
      list-style-type: demical;

      li {
        list-style-type: demical;
        list-style-position: inside;
      }
    }
  }
  .chk_noWte {
    padding: 0 1rem;
  }
  .btn_submit {
    text-align: center;
  }
  .price-dialog {
    min-width: 20%;
    font-weight: 600;
    ::v-deep .el-dialog {
      width: 90%;
      .el-dialog__title {
        font-size: 1.8rem;
      }
      .el-dialog__headerbtn {
        font-size: 2.5rem;
      }
    }
  }

  ::v-deep .price-dialog .el-dialog__body {
    padding: 1rem 2rem;
  }
  .title-divider {
    margin-bottom: 1rem;
    margin-top: -1rem;
    height: 2px;
    background-color: $btn-bg-color;
    border-top: none;
  }
  .title{
    font-weight: 600;
  }
  .colorRed{
    color:$btn-bg-color;
    font-size:11px;
  }
  ::v-deep li a{
    color: $btn-bg-color;
  }
  .s_btn{
    width: 35rem;
    border-radius: 20px;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: $btn-bg-color;
    border-color: $btn-bg-color;
  }
}
/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .info_detal_r {
    width: 40%;
    padding: 1.3rem;
    font-size: 1.2rem;
    font-weight: 400;
  }
  .side_sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }
  .booking_price {
    border-bottom: 0.2rem dashed $bg-color;
  }
  .total-price {
    font-size: 3rem;
    line-height: 4.2rem;
    display: flex;
    justify-content: space-between;
    padding-bottom: 1.3rem;
  }
  .price_link {
    text-align: right;
    padding-bottom: 1.3rem;
    font-size: 1.8rem;
    line-height: 2.5rem;
  }
  .content-title {
    font-size: 1.6rem;
    color: orange;
    margin-top: 1rem;
  }
  .policies_title {
    line-height: 2rem;
    font-size: 1.4rem;
    padding: 0.5rem 0px;
  }
  .guarantee_rules {
    font-size: 1.2rem;
    ul {
      list-style-type: demical;

      li {
        list-style-type: demical;
        list-style-position: inside;
      }
    }
  }
  .colorRed{
    color:red;
    font-size:1.2rem;
    margin-top:0.5rem;
  }
  .btn_submit {
    text-align: center;
  }
  .price-dialog{
    min-width: 20%;
    font-weight: 600;
    ::v-deep .el-dialog {
      width: 40%;
    }
  }

  ::v-deep .price-dialog .el-dialog__body {
    padding: 1rem 2rem;
  }
  .title-divider {
    margin-bottom: 1rem;
    margin-top: -1rem;
    height: 2px;
    background-color: $btn-bg-color;
  }
  .title{
    font-weight: 600;
  }
}
.chk_noWte {
  ::v-deep .el-checkbox {
    display: flex;
    align-items: flex-start;
    max-width: 100%;
    white-space: normal;
  }
  ::v-deep .el-checkbox__input {
    flex: 0 0 auto;
    padding-top: 0.2rem;
  }
  ::v-deep .el-checkbox__label {
    flex: 1;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    line-height: 1.8rem;
  }
}
/* 关键：让换行生效 */
.tooltip-multi-line {
  white-space: pre-line; 
  text-align: left;
}

.tooltip-content {
    white-space: pre-line;
    text-align: left;
    padding: 5px 5px;
    max-width: 500px; /* PC 最大宽度 */
}

@media screen and (min-width: 961px) {
  .title-text {
    color: #ffa500; /* 橙色 */
  }
}

@media screen and (max-width: 960px) {
  .title-text {
    color: #000; /* 黑色 */
  }
  .tooltip-content {
    padding: 5px 5px 5px 15px;
    max-width: 100vw;
  }
}

</style>
